import { useEffect, useState } from 'react';

// Returns a value that lags behind `value` by `ms` milliseconds. Each new
// `value` resets the timer; the debounced output only catches up after the
// caller has been idle for the full window. Used by the attendees-list
// search to keep typing responsive while the (potentially large) filtered
// list is recomputed.
export function useDebouncedValue<T>(value: T, ms: number = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return debounced;
}
